import "./CollectionGold.module.css";
import Header from "@/reusable_sections/Header";
import LuxuryGatwickAirportChauffeurTransfer from "./sections/LuxuryGatwickAirportChauffeurTransfer";
import Projects from "./sections/Projects";
import CulturalCulinaryExperience from "./sections/CulturalCulinaryExperience";
import SecureYourEvening from "./sections/SecureYourEvening";
import FooterInfo from "@/reusable_sections/Footer";
export default function CollectionGoldPage() {
  return <div>
      <Header />
      <LuxuryGatwickAirportChauffeurTransfer />
      <Projects />
      <CulturalCulinaryExperience />
      <SecureYourEvening />
      <FooterInfo />
    </div>;
}